"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LikertInput = void 0;
const React = require("react");
const react_1 = require("react");
const Icon_1 = require("../../atoms/Icon");
const cssComposer_1 = require("../../../../helpers/cssComposer");
const styles = require("./styles.scss");
const predeterminedScales_1 = require("./helpers/predeterminedScales"); // Presets created in a separate file. They took up to much room!
/*
  creates a variable containing a multitude of presets, if adding a preset be sure to extend the preset type,
  the pattern is as follows; icon set followed by the amount of options. I.E happiness10 is the happiness icon set with a 10 rating scale
*/
const predeterminedScales = {
    pain11Partial: predeterminedScales_1.pain11Partial,
    pain11Full: predeterminedScales_1.pain11Full,
    happiness10: predeterminedScales_1.happiness10,
    pain6: predeterminedScales_1.pain6,
    happiness7: predeterminedScales_1.happiness7,
    happiness5: predeterminedScales_1.happiness5
};
const css = (0, cssComposer_1.default)(styles);
const LikertInput = (props) => {
    const { onInputChange, scales, value, preset, layout = "row" } = props;
    const [currentValue, setCurrentValue] = (0, react_1.useState)(value); // used as an initializer for the value
    const [currentScale, setCurrentScale] = (0, react_1.useState)(null); // used as the scale to render in the ui
    // watch's preset prop and dependent on preset value will either set scale to predetermined set or use custom set
    (0, react_1.useEffect)(() => {
        let selectedScales;
        if (!preset && scales) {
            selectedScales = scales;
        }
        else {
            selectedScales = predeterminedScales[preset];
        }
        setCurrentScale(selectedScales);
    }, [preset]);
    // value can be passed in as a prop and populates the state value
    (0, react_1.useEffect)(() => setCurrentValue(value), [value]);
    // consolidate value change event, which sets state and runs default callback passed into input
    const changeEvent = (event) => {
        const newValue = parseFloat(event.target.value);
        setCurrentValue(newValue);
        onInputChange(newValue);
    };
    // layout is defaulted to row, but if column is required we apply the columns class
    const containerClass = layout === "row"
        ? css("ratingsContainer")
        : css("ratingsContainer", "ratingsColumn");
    return (React.createElement(React.Fragment, null, currentScale ? (React.createElement("div", { className: containerClass }, currentScale.map((scaleEntry, key) => {
        const isCurrentValue = scaleEntry.value === currentValue;
        // dynamically apply the size of the icons based off the amount of options supplied
        const iconClass = css({ selectedRating: isCurrentValue }, { iconLg: currentScale.length <= 6 }, { iconMid: currentScale.length > 6 && currentScale.length <= 10 }, { iconSmall: currentScale.length > 10 });
        // if icon is not set and we use a mock radio button, work out which class based on if this value is current
        const radioButtonClass = isCurrentValue
            ? css("radio-button-checked")
            : css("radio-button-unchecked");
        const iconName = isCurrentValue
            ? scaleEntry.iconSelected
            : scaleEntry.icon;
        return (React.createElement("label", { className: styles.rating, key: key },
            scaleEntry.icon ? (React.createElement(Icon_1.Icon, { className: iconClass, name: iconName })) : (React.createElement("span", { className: radioButtonClass })),
            React.createElement("input", { type: "radio", value: scaleEntry.value, checked: scaleEntry.value === currentValue, onChange: event => changeEvent(event) }),
            React.createElement("span", null,
                " ",
                scaleEntry.value,
                " "),
            scaleEntry.label ? (React.createElement("span", { className: styles.label },
                " ",
                scaleEntry.label,
                " ")) : null));
    }))) : null));
};
exports.LikertInput = LikertInput;
//# sourceMappingURL=index.js.map